import React, { Fragment } from 'react';
import { Notice, List } from 'telia-front-react';
import { observer } from 'mobx-react';
const TradeInMultipleError = ({ tradeInStore: { imeiValidation: { response }, }, translate, }) => {
    return (React.createElement(Notice, { type: "error" },
        `${translate('tradeIn.form.imei.errors.nomatch')}`,
        response.items.length && (React.createElement(Fragment, null,
            React.createElement(List, null, response.items.map((i) => (React.createElement("p", { key: i.deviceId },
                React.createElement("b", null, i.name))))))),
        `${translate('tradeIn.form.imei.errors.nomatch.continue')}`));
};
export default observer(TradeInMultipleError);
